import React from 'react';

export interface FolderKpiCardProps {
  label: string;
  value: React.ReactNode;
  sub?: React.ReactNode;
  /** Brand colour for the headline figure (Total price). */
  highlight?: boolean;
  /** Under the secondary line, never cut: the total price breakdown. */
  details?: React.ReactNode;
}

/** KD-3842 client folder KPI: label, figure and a secondary line. */
export default function FolderKpiCard({
  label,
  value,
  sub,
  highlight = false,
  details,
}: FolderKpiCardProps) {
  return (
    <div className="flex min-w-0 flex-col gap-1 rounded-2xl border border-solid border-k-gray bg-white px-4 py-3.5">
      <span className="text-[11px] font-semibold uppercase tracking-wider text-gray-500">
        {label}
      </span>
      <span
        className={`truncate text-2xl font-bold tabular-nums ${
          highlight ? 'text-brand' : 'text-gray-900'
        }`}
      >
        {value}
      </span>
      {/* Two lines at most: the total price breakdown wraps on narrow screens. */}
      {sub && (
        <span
          className="line-clamp-2 text-xs text-gray-500"
          title={typeof sub === 'string' ? sub : undefined}
        >
          {sub}
        </span>
      )}
      {details}
    </div>
  );
}
